import UserPreferences from './UserPreferences';
import * as config from '../config';
import * as idcta from '../idcta';

const ptrt = encodeURIComponent(window.location.href.replace(window.location.hash, ''));

export function convertHtml(html) {
    let htmlJs;

    const escapedHtml = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, (x) => {
        let script = x.substring(x.indexOf('>') + 1);
        script = script.slice(0, script.indexOf('</script'));
        htmlJs = script;
        return '';
    });

    const result = { html: escapedHtml };

    if (htmlJs) {
        result.htmlJs = encodeURI(htmlJs);
    }

    return result;
}

function checkStatus(response) {
    if (response.ok) {
        return response;
    }

    const error = new Error(`HTTP request failed ${response.statusText}`);
    error.response = response;
    throw error;
}

function fetchIdcta() {
    return new Promise((resolve, reject) => idcta.lib().then((idctaLib) => {
        const userDetails = idctaLib.getUserDetailsFromCookie() || {};

        if (idctaLib.hasCookie() && userDetails.ab !== 'u13') {
            return resolve(null);
        }

        return fetch(`${config.env.preferencesUrls.idcta}?policy=notification&buttonColour=white&ptrt=${ptrt}`, {
            credentials: 'include'
        })
        .catch((err) => {
            throw err;
        })
        .then(checkStatus)
        .then((res) => res.json())
        .then((data) => {
            if (data.html) {
                const convertedHtml = convertHtml(data.html);

                data.html = convertedHtml.html;
                if (convertedHtml.htmlJs) {
                    data.htmlJs = convertedHtml.htmlJs;
                }
            }

            return data;
        })
        .then((data) => resolve(data));
    })
    .catch((err) => {
        reject(err);
    }));
}

export class UserState {
    isSignedIn() {
        return idcta.lib().then((idctaLib) => idctaLib.hasCookie());
    }

    isOnboarded() {
        return idcta.lib().then((idctaLib) => {
            const userDetails = idctaLib.getUserDetailsFromCookie();

            if (userDetails && userDetails.ab === 'u13') {
                return true;
            }

            return UserPreferences.fetch().then((userPreferences) =>
                ((userPreferences !== null &&
                    typeof userPreferences.preferences.hasOnboarded !== 'undefined') ?
                    userPreferences.preferences.hasOnboarded : false));
        });
    }

    setIdctaResponse(response, idctaData) {
        response.idctaResponse = idctaData;

        if (idctaData.policyCheck) {
            response.policyIssue = Object.keys(idctaData.policyCheck)[0];
        }
    }

    load() {
        return Promise.all([this.isSignedIn(), fetchIdcta()])
            .catch((err) => {
                throw err;
            })
            .then(([signedIn, idctaData]) => {
                const response = { signedIn };

                if (idctaData) {
                    this.setIdctaResponse(response, idctaData);
                }

                if (!signedIn) {
                    return response;
                }

                return this.isOnboarded().then((onboarded) => {
                    response.onboarded = onboarded;

                    return response;
                });
            });
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/UserState.js
 **/